import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzEaster70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_70: Record<
  Exclude<PageIdWoofzEaster70, PageIdWoofzEaster70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_EASTER_70]: {
    id: PageId.SUBSCRIPTIONS_EASTER_70,
  },
  [PageId.CHAT_UPSELL_EASTER_70]: {
    id: PageId.CHAT_UPSELL_EASTER_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EASTER_70]: {
    id: PageId.UPSELL_EASTER_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_EASTER_70]: {
    id: PageId.DOWNLOAD_EASTER_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
